import { render, staticRenderFns } from "./AHeader.vue?vue&type=template&id=8ba03b4a&scoped=true"
import script from "./AHeader.vue?vue&type=script&lang=js"
export * from "./AHeader.vue?vue&type=script&lang=js"
import style0 from "./AHeader.vue?vue&type=style&index=0&id=8ba03b4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba03b4a",
  null
  
)

export default component.exports